var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#ccc"}},[_c('div',{staticStyle:{"width":"840px","margin":"auto","background":"#fff"}},[_c('PatientCaseReport',{attrs:{"value":_vm.$route.params.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }